import { alpha } from "@mui/material/styles";
import { green, red, yellow } from "@mui/material/colors";

export const greenColor = alpha(green[500], 0.2);
export const yellowColor = alpha(yellow[700], 0.2);
export const redColor = alpha(red[500], 0.2);
